/*
 * Copyright (c) Nexign, JSC, 2021-2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babnov
 * @version 1.2.0
 * @since 1.14.0
 */

import { useFormikContext } from 'formik';

import { Checkbox } from '@components/common';
import { ICheckboxProps } from '@components/common/Checkbox/Checkbox';
import { FormCheckboxBlockStyled } from '@components/common/FormStyled/FormStyled';

import FormField, { IFormFieldProps } from './FormField';

type TFormFieldCheckboxProps = IFormFieldProps & Partial<ICheckboxProps>;

const FormFieldCheckbox = (props: TFormFieldCheckboxProps) => {
    const { setFieldValue } = useFormikContext();

    return (
        <FormField {...props}>
            {({ field, label, dataName }) => {
                const onChange = (value: boolean) => {
                    props.onChange?.(value);
                    setFieldValue(field.name, value);
                };

                return (
                    <FormCheckboxBlockStyled>
                        <Checkbox
                            checked={field.value}
                            dataName={dataName}
                            disabled={props.disabled}
                            id={props.id}
                            label={label}
                            onChange={onChange}
                        />
                    </FormCheckboxBlockStyled>
                );
            }}
        </FormField>
    );
};

export default FormFieldCheckbox;
